import CoinSmart from '@/assets/images/rever-store/coin-smart.svg'
import CoinPremium from '@/assets/images/rever-store/coin-premium.svg'
import CoinProfessional from '@/assets/images/rever-store/coin-professional.svg'
import reverPlans from '@/ui/components/rever-store/store-data/plans.json'

interface PlansProps {
  selectedPlan: number | undefined
  selectPlan: (index: number) => void
}

export const Plans: React.FC<PlansProps> = ({ selectedPlan, selectPlan }) => {
  return (
    <>
      {selectedPlan !== undefined ? (
        <div className="flex w-full items-center justify-center">
          {selectedPlan === 0 && (
            <img className="mb-4 w-48 drop-shadow-lg" src={CoinSmart} />
          )}
          {selectedPlan === 1 && (
            <img className="mb-4 w-48 drop-shadow-lg" src={CoinPremium} />
          )}
          {selectedPlan === 2 && (
            <img className="mb-4 w-48 drop-shadow-lg" src={CoinProfessional} />
          )}
        </div>
      ) : (
        <div className="relative mx-auto mb-5 flex h-[300px] gap-12 overflow-hidden">
          <div className="absolute inset-y-0 left-0 z-50 w-48 bg-gradient-to-r from-grey-6 to-transparent" />
          <div className="absolute inset-y-0 right-0 z-50 w-48 bg-gradient-to-l from-grey-6 to-transparent" />
          <div className="animate-scroll-horizontal absolute left-full mt-6 flex w-full justify-around whitespace-nowrap">
            <img
              className="mb-4 w-48 drop-shadow-lg transition-all duration-500 hover:scale-125"
              src={CoinSmart}
              onClick={() => selectPlan(0)}
            />
            <img
              className="mb-4 w-48 drop-shadow-lg transition-all duration-500 hover:scale-125"
              src={CoinPremium}
              onClick={() => selectPlan(1)}
            />
            <img
              className="mb-4 w-48 drop-shadow-lg transition-all duration-500 hover:scale-125"
              src={CoinProfessional}
              onClick={() => selectPlan(2)}
            />
          </div>
          <div className="animate-scroll-horizontal absolute left-full mt-6 flex w-full justify-around whitespace-nowrap delay-[8s]">
            <img
              className="mb-4 w-48 drop-shadow-lg transition-all duration-500 hover:scale-125"
              src={CoinSmart}
              onClick={() => selectPlan(0)}
            />
            <img
              className="mb-4 w-48 drop-shadow-lg transition-all duration-500 hover:scale-125"
              src={CoinPremium}
              onClick={() => selectPlan(1)}
            />
            <img
              className="mb-4 w-48 drop-shadow-lg transition-all duration-500 hover:scale-125"
              src={CoinProfessional}
              onClick={() => selectPlan(2)}
            />
          </div>
        </div>
      )}
      {selectedPlan !== undefined && (
        <div className="mb-10 flex flex-col items-center justify-center">
          <span className="font-logo text-5xl uppercase ">
            {reverPlans[selectedPlan].name}
          </span>
          <span className="text-2xl font-semibold ">
            {reverPlans[selectedPlan].subtitle}
          </span>
          <span className="text-lg ">
            {reverPlans[selectedPlan].description}
          </span>
        </div>
      )}
      <div className="flex w-full flex-col">
        <div className="mx-auto mb-10 flex gap-4">
          {reverPlans.map((plan, index) => (
            <div
              onClick={() => selectPlan(index)}
              className={
                'cursor-pointer rounded-full border border-solid border-slate-700 px-6 py-1 transition-all hover:bg-slate-700 hover:text-white ' +
                (index === selectedPlan
                  ? 'bg-slate-700 text-white'
                  : 'bg-transparent text-slate-700')
              }
              key={index}
            >
              <p className="text-xl">{plan.name}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
export default Plans
